import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-textDec",
  "use": "icon-textDec-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-textDec\">\r\n<g clip-path=\"url(#icon-textDec_clip0_1394_682)\">\r\n<path d=\"M11.012 4.75586C11.4384 4.75586 11.784 5.1015 11.784 5.52786C11.784 5.95422 11.4384 6.29986 11.012 6.29986H8.864V11.6239C8.864 12.1121 8.46822 12.5079 7.98 12.5079C7.49178 12.5079 7.096 12.1121 7.096 11.6239V6.29986H4.948C4.52164 6.29986 4.176 5.95422 4.176 5.52786C4.176 5.1015 4.52164 4.75586 4.948 4.75586H11.012ZM14.224 2.63586H1.776V14.8679H14.224V2.63586ZM14.856 0.755859C15.488 0.755859 16 1.26786 16 1.89986V15.6119C16 16.2439 15.488 16.7559 14.856 16.7559H1.144C0.512 16.7559 0 16.2439 0 15.6119V1.89986C0 1.26786 0.512 0.755859 1.144 0.755859H14.856Z\" fill=\"#AAAEB3\" />\r\n</g>\r\n<defs>\r\n<clipPath id=\"icon-textDec_clip0_1394_682\">\r\n<rect width=\"16\" height=\"16\" fill=\"white\" transform=\"translate(0 0.755859)\" />\r\n</clipPath>\r\n</defs>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/textDec.svg
// module id = mXwQ
// module chunks = 14